import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { isMobile, isTablet } from "react-device-detect";
import ReactGA from "react-ga4";
import MainLayout from "./layouts/MainLayout";
import Home from "./pages/Home/Home";
import HomeMobile from "./pages/Home/HomeMobile";
import HomeMidSeason from "./pages/Home/Home-MidSeason";
import Genre from "./pages/Genre/Genre";
import ShowLayout from "./layouts/ShowLayout";
import ShowHome from "./pages/Show/ShowHome";
import ShowAwardsDetail from "./pages/Show/Awards/ShowAwardsDetail";
import MediaDetail from "./pages/Show/Media/MediaDetail";
import AnalyticsRouteTracker from "./utils/Tracking/AnalyticsRouteTracker";
import { ScreenerLogin } from "./components/Screeners/ScreenerLogin";
import { ScreenerProjectList } from "./components/Screeners/ScreenerProjectList";
// import { fetchIndeeProjects } from "./utils/api/helpers/indee";
// import {
//   setScreenerLoggedIn,
//   setIndeeApiChecked,
//   useAuthActionFlag,
// } from "./utils/Screeners/useScreeners";
import StaticPage from "./pages/StaticPage/StaticPage";
import EventList from "./pages/Event/EventList";
import EventDetail from "./pages/Event/components/EventDetail";
import { MID_SEASON_MODE } from "./data/globalConstants";
import UpdateRSVP from "./pages/Rsvp/UpdateRsvp";
import TaggedMediaPage from "./pages/Show/Media/TaggedMediaPage";

function App() {
  // const authActionFlag = useAuthActionFlag();
  const HomeComponent = isMobile && !isTablet ? HomeMobile : Home;

  // useEffect(() => {
  //   fetchIndeeProjects().then((result) => {
  //     // console.log("fetchIndeeProjects", result);
  //     setScreenerLoggedIn(!(result.data.error && result.data.message.unauth));
  //     setIndeeApiChecked(true);
  //   });
  // }, [authActionFlag, setScreenerLoggedIn]);

  useEffect(() => {
    let subscribed = true;
    if (subscribed) {
      ReactGA.initialize([
        {
          trackingId: "G-S371Q8G4DD",
        },
        {
          trackingId: "DC-4968236",
        },
      ]);
      ReactGA.event({
        category: "conversion",
        allow_custom_scripts: true,
        send_to: "DC-4968236/awardfyc/dcmna00+standard",
      });
      ReactGA.send("pageview");
    }
    return () => {
      subscribed = false;
    };
  }, []);

  if (!MID_SEASON_MODE) {
    return (
      <>
        <Router>
          <Routes>
            {/* Wrap everything in the MainLayout */}
            <Route element={<MainLayout />}>
              <Route path="/" element={<HomeComponent />} />

              {["/privacy", "/terms", "/privacy-and-terms"].map((p) => (
                <Route
                  key={p}
                  path={p}
                  element={
                    <StaticPage
                      pageTitle="Terms of Use and Privacy Statement"
                      pageSlug="privacy"
                    />
                  }
                />
              ))}

              <Route
                path="/do-not-sell-or-share"
                element={
                  <StaticPage
                    pageTitle={"Do Not Sell or Share My Personal Information"}
                    pageSlug={"do-not-sell-or-share"}
                  />
                }
              />

              <Route path={"updatersvp"} element={<UpdateRSVP />} />
              <Route path={"updatersvp/:hash"} element={<UpdateRSVP />} />

              <Route path="events" element={<EventList />} />
              <Route path="events/:eventSlug" element={<EventDetail />} />

              <Route path=":genreSlug" element={<Genre />} />
              {/* Show layout + nested routes */}
              <Route path=":genreSlug/:showSlug" element={<ShowLayout />}>
                {/* Default show page */}
                <Route index element={<ShowHome />} />

                {/* Awards page route */}
                <Route path="awards" element={<ShowAwardsDetail />} />

                <Route
                  path="video/creator-diaries"
                  element={
                    <TaggedMediaPage
                      tag="creator-diaries"
                      pageTitle="Creator Diaries"
                      sectionTitle="Creator Diaries"
                    />
                  }
                />

                {/* Section route, e.g., video, press, audio */}
                <Route path=":sectionSlug" element={<ShowHome />} />

                {/* Media detail under a section */}
                <Route
                  path=":sectionSlug/:mediaSlug"
                  element={<MediaDetail />}
                />
              </Route>
            </Route>
          </Routes>
          <AnalyticsRouteTracker />
        </Router>
        <ScreenerLogin />
        <ScreenerProjectList />
      </>
    );
  } else {
    return (
      <>
        <Router>
          <Routes>
            {/* Wrap everything in the MainLayout */}
            <Route element={<MainLayout />}>
              <Route path="*" element={<HomeMidSeason />} />
            </Route>
          </Routes>
        </Router>
      </>
    );
  }
}

export default App;
